<template>
  <Head :title="event.sqid ? $t('update :t', { t: event.title }) : 'nieuwe activiteit'" />

  <main class="events update">
    <section>
      <header>
        <div>
          <h2>Agenda</h2>
          <h1>{{ event.sqid ? event.title : 'nieuwe activiteit' }}</h1>
        </div>
      </header>

      <form @submit.prevent="submitForm">
        <fieldset>
          <div class="field">
            <label>datum</label>
            <div>
              <input v-model="form.date" type="date" name="date" />
              <FormError :error="form.errors.date" />
            </div>
          </div>

          <div class="field">
            <label>activiteit</label>
            <div>
              <input v-model="form.title" type="text" name="title" />
              <FormError :error="form.errors.title" />
            </div>
          </div>

          <div class="field">
            <label>location / restaurant</label>
            <div>
              <input v-model="form.location" type="text" name="location" />
              <FormError :error="form.errors.location" />
            </div>
          </div>

          <div class="field">
            <label>omschrijving</label>
            <div>
              <textarea v-model="form.description" rows="6" cols="40" class="autosize"></textarea>
              <FormError :error="form.errors.description" />
            </div>
          </div>

          <div class="field">
            <label>bevestigd</label>
            <div>
              <label class="checkbox">
                <input v-model="form.confirmed" type="checkbox" name="confirmed" />
                <span class="label">deze activiteit is bevestigd en moet op de agenda getoond worden.</span>
              </label>
            </div>
          </div>
        </fieldset>

        <footer>
          <fieldset class="actions">
            <button type="submit" class="success" :disabled="form.processing">
              <Icon name="plus" /> {{ $t('save') }}
            </button>
          </fieldset>
        </footer>
      </form>
    </section>
  </main>
</template>

<script lang="ts" setup>
import { Head, useForm } from '@inertiajs/vue3'
import { toast } from 'vue-sonner'

import FormError from '/@admin:components/FormError.vue'
import Icon from '/@admin:components/Icon.vue'
import AuthLayout from '/@admin:layouts/Auth.vue'
import { $t } from '/@admin:shared/i18n'
import type { Event } from '/@admin:types'

defineOptions({
  layout: [AuthLayout],
})

const props = defineProps<{
  event: Event
}>()

const form = useForm({
  title: props.event.title,
  location: props.event.location,
  description: props.event.description,
  date: props.event.date,
  confirmed: props.event.confirmed,
})

const submitForm = () => {
  form.post(location.pathname, {
    onSuccess: () => {
      toast.success('Activiteit opgeslagen')
    },
  })
}
</script>
